import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import { environment } from '../environments/environment';
import { AuthorizationService } from '../services/authorization.service';

@Injectable()
export class AppInsightsService {

    appInsights: ApplicationInsights;

    constructor(private authService: AuthorizationService) {
        this.appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: environment.applicationInsights.instrumentationKey,
                enableAutoRouteTracking: true // option to log all route changes
            }
        });
        this.appInsights.loadAppInsights();
    }

    logPageView(name?: string, url?: string, properties?: any, measurements?: any, duration?: number) {
        this.setUser();
        this.appInsights.trackPageView({ name: name, uri: url });
    }

    logEvent(name: string, properties?: any, measurements?: any) {
        this.setUser();
        this.appInsights.trackEvent({ name: name }, properties);
    }

    logException(exception: Error, handledAt?: string, properties?: any, measurements?: any) {
        this.setUser();
        this.appInsights.trackException({ exception: exception }, { handledAt, properties, measurements });
    }

    logTrace(message: string, properties?: any, severityLevel?: any) {
        this.setUser();
        this.appInsights.trackTrace({ message: message }, properties);
    }

    setUser() {
        if (this.authService.authenticated()) {
            this.appInsights.setAuthenticatedUserContext(this.authService.getUsername());
        } else {
            this.appInsights.clearAuthenticatedUserContext();
        }
    }
}